import * as actionTypes from "./actionTypes";

// Bookmark Restaurant
export const loadBookmarkRestaurantList = data => {
  return {
    type: actionTypes.LOAD_BOOKMARK_RESTAURANT_LIST,
    data
  };
};

export const loadBookmarkRestaurantListSuccess = data => {
  return {
    type: actionTypes.LOAD_BOOKMARK_RESTAURANT_LIST_SUCCESS,
    data
  };
};

export const loadBookmarkRestaurantListFail = () => {
  return {
    type: actionTypes.LOAD_BOOKMARK_RESTAURANT_LIST_FAIL
  };
};

export const substituteBookmarkRestaurant = data => {
  return {
    type: actionTypes.SUBSTITUTE_BOOKMARK_RESTAURANT,
    data
  };
};

export const substituteBookmarkRestaurantSuccess = () => {
  return {
    type: actionTypes.SUBSTITUTE_BOOKMARK_RESTAURANT_SUCCESS
  };
};

export const substituteBookmarkRestaurantFail = () => {
  return {
    type: actionTypes.SUBSTITUTE_BOOKMARK_RESTAURANT_FAIL
  };
};
// END Bookmark Restaurant

// Don't Show Restaurant
export const loadDislikeRestaurantList = data => {
  return {
    type: actionTypes.LOAD_DISLIKE_RESTAURANT_LIST,
    data
  };
};

export const loadDislikeRestaurantListSuccess = data => {
  return {
    type: actionTypes.LOAD_DISLIKE_RESTAURANT_LIST_SUCCESS,
    data
  };
};

export const loadDislikeRestaurantListFail = () => {
  return {
    type: actionTypes.LOAD_DISLIKE_RESTAURANT_LIST_FAIL
  };
};

export const substituteDislikeRestaurant = data => {
  return {
    type: actionTypes.SUBSTITUTE_DISLIKE_RESTAURANT,
    data
  };
};

export const substituteDislikeRestaurantSuccess = () => {
  return {
    type: actionTypes.SUBSTITUTE_DISLIKE_RESTAURANT_SUCCESS
  };
};

export const substituteDislikeRestaurantFail = () => {
  return {
    type: actionTypes.SUBSTITUTE_DISLIKE_RESTAURANT_FAIL
  };
};
// END Don't Show Restaurant

// View History Restaurant
export const loadViewHistoryRestaurantList = data => {
  return {
    type: actionTypes.LOAD_VIEW_HISTORY_RESTAURANT_LIST,
    data
  };
};

export const loadViewHistoryRestaurantListSuccess = data => {
  return {
    type: actionTypes.LOAD_VIEW_HISTORY_RESTAURANT_LIST_SUCCESS,
    data
  };
};

export const loadViewHistoryRestaurantListFail = () => {
  return {
    type: actionTypes.LOAD_VIEW_HISTORY_RESTAURANT_LIST_FAIL
  };
};

export const insertViewHistoryRestaurant = data => {
  return {
    type: actionTypes.INSERT_VIEW_HISTORY_RESTAURANT,
    data
  };
};

export const insertViewHistoryRestaurantSuccess = () => {
  return {
    type: actionTypes.INSERT_VIEW_HISTORY_RESTAURANT_SUCCESS
  };
};

export const insertViewHistoryRestaurantFail = () => {
  return {
    type: actionTypes.INSERT_VIEW_HISTORY_RESTAURANT_FAIL
  };
};

export const deleteViewHistoryRestaurant = data => {
  return {
    type: actionTypes.DELETE_VIEW_HISTORY_RESTAURANT,
    data
  };
};

export const deleteViewHistoryRestaurantSuccess = () => {
  return {
    type: actionTypes.DELETE_VIEW_HISTORY_RESTAURANT_SUCCESS
  };
};

export const deleteViewHistoryRestaurantFail = () => {
  return {
    type: actionTypes.DELETE_VIEW_HISTORY_RESTAURANT_FAIL
  };
};

export const deleteViewHistoryRestaurantList = () => {
  return {
    type: actionTypes.DELETE_VIEW_HISTORY_RESTAURANT_LIST
  };
};

export const deleteViewHistoryRestaurantListSuccess = () => {
  return {
    type: actionTypes.DELETE_VIEW_HISTORY_RESTAURANT_LIST_SUCCESS
  };
};

export const deleteViewHistoryRestaurantListFail = () => {
  return {
    type: actionTypes.DELETE_VIEW_HISTORY_RESTAURANT_LIST_FAIL
  };
};

// END View History Restaurant

// Remove Multiple
export const deleteMultipleBookmarkOrDislikeRestaurant = data => {
  return {
    type: actionTypes.DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT,
    data
  };
};

export const deleteMultipleBookmarkOrDislikeRestaurantSuccess = () => {
  return {
    type: actionTypes.DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT_SUCCESS
  };
};

export const deleteMultipleBookmarkOrDislikeRestaurantFail = () => {
  return {
    type: actionTypes.DELETE_MULTIPLE_BOOKMARK_OR_DISLIKE_RESTAURANT_FAIL
  };
};

// Remove All
export const deleteBookmarkOrDislikeRestaurantList = data => {
  return {
    type: actionTypes.DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST,
    data
  };
};

export const deleteBookmarkOrDislikeRestaurantListSuccess = () => {
  return {
    type: actionTypes.DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST_SUCCESS
  };
};

export const deleteBookmarkOrDislikeRestaurantListFail = () => {
  return {
    type: actionTypes.DELETE_BOOKMARK_OR_DISLIKE_RESTAURANT_LIST_FAIL
  };
};
// END Remove All
